module.exports = __webpack_public_path__ + "static/media/injuredPressure.b7f68285.mp3";